import { useQuery } from '@tanstack/react-query'

import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AiChatApi } from 'src/services/aiChatApi'

export const useGetAiChatConversationsQuery = () => {
  return useQuery({
    queryFn: () => AiChatApi.getConversations(),
    queryKey: [QueryKey.GET_AI_CHAT_CONVERSATIONS],
  })
}
